<template>
  <section class="exit-page">
    <div class="warning-box">
      <i class="fas fa-exclamation-circle icon-alert"></i>
      <p class="are-you-sure">{{ t('are_you_sure') }}</p>
      <p class="alert-message">{{ t('alert_message_exit') }}</p>
    </div>

    <div class="buttons-group">
      <button class="button-body" type="button" @click="changeUser">
        <i class="fa fa-exchange-alt me-2"></i>
        {{ t('change_user') }}
      </button>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { useLangStore } from '@/stores/lang';
import { useDebugStore } from '@/stores/debug';
import { useTopbarStore } from '@/stores/topbar';
import { useViewerStore } from '@/stores/viewer';

const router = useRouter();
const { t } = useI18n();
const langStore = useLangStore();
const debugStore = useDebugStore();
const topbarStore = useTopbarStore();
const viewerStore = useViewerStore();

function changeUser() {
  const currentLang = langStore.translation || localStorage.getItem('translation') || 'ru';
  const savedAccounts = localStorage.getItem('accounts');
  localStorage.clear();
  localStorage.setItem('translation', currentLang);
  if (savedAccounts) {
    localStorage.setItem('accounts', savedAccounts);
  }
  debugStore.resetDebugSettings();
  langStore.changeLang(currentLang);

  viewerStore.$reset();
  topbarStore.clear();

  router.push('/login');
}

onMounted(() => {
  topbarStore.setTitle(t('change_user'));
  topbarStore.addButton({
    type: 'left',
    icon: 'keyboard_backspace',
    action: () => router.push('/settings')
  });
});
</script>

<style scoped>
.exit-page {
  padding: 24px;
}

.warning-box {
  text-align: center;
  background: #fff;
  border-radius: 6px;
  padding: 24px 16px;
}

.icon-alert {
  font-size: 72px;
  color: #eb5757;
  margin-bottom: 25px;
}

.are-you-sure {
  color: #eb5757;
  font-weight: 700;
  font-size: 24px;
  line-height: 21px;
}

.alert-message {
  color: #828282;
  margin: 12px 0 0;
}

.buttons-group {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.button-body {
  width: min(620px, 100%);
  min-height: 36px;
  padding: 4px 20px;
  border: none;
  border-radius: 2px;
  color: #fff;
  background: #36b453;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.24);
}
</style>
